export default {
  Name: 'MHC EngageCX' //IconURL: '', //use default icon
  //Color: '#289fcb',//use as specified in theme

};